module.exports = __webpack_public_path__ + "static/media/stop-finish.b90e78c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/stop-finish.svg
// module id = 746
// module chunks = 0